const raw = (typeof window !== 'undefined' && window.__API_BASE__) || process.env.REACT_APP_API_BASE || '';



const API_BASE = (() => {
	const value = (raw || '').toString().trim();
	const parts = value.split(',').map(s => s.trim()).filter(Boolean);
	const configuredBase = (parts[0] || '').replace(/\/+$/, '');
	const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
	const isLocalBrowser = /^(localhost|127\.0\.0\.1)$/i.test(hostname);
	const isDirectAppPort = /:8003(?:\/|$)/i.test(configuredBase);

	// The public app is served through HTTPS and must use the reverse-proxy path.
	// Port 8003 is only the private backend listener/local development target.
	if (!configuredBase) return isLocalBrowser ? 'http://localhost:8003' : '/api';
	if (!isLocalBrowser && isDirectAppPort) return '/api';
	return configuredBase;
})();



export default API_BASE;